module.exports = __webpack_public_path__ + "static/media/youtube.c80ca203.svg";